import axios from "axios";
import QueryString from "qs";
import l10n from "../lib/l10n";

const useXHR = () => {
  return {
    post: async data => axios.post(l10n.url_admin.toString(), QueryString.stringify(data)),
  }
};

export default useXHR;
